import * as api from "@/entities/bot-builder"
import { draftCache as cache } from "@/entities/bot-builder"
import type { ActionsContext } from "./types"

export function createEdgeActions({ enqueue, scenarioId }: ActionsContext) {
	return {
		putEdge: (edge: { sourceNodeId: string; sourcePort: string; targetNodeId: string }) =>
			enqueue(
				"Не удалось связать блоки",
				(baseRevision) => api.putEdge(scenarioId, { ...edge, baseRevision }),
				(draft, result) => cache.upsertEdge(draft, result.edge),
			),

		deleteEdge: (edgeId: string) =>
			enqueue(
				"Не удалось удалить связь",
				(baseRevision) => api.deleteEdge(scenarioId, edgeId, baseRevision),
				(draft) => cache.removeEdges(draft, [edgeId]),
			),
	}
}
